import React, { useState, useEffect } from 'react';
import _ from 'lodash';

const getIndiceFromLength = (array, currIndice, direction) => {
    
    let length = array.length;
    if(direction === 'forward'){
        if(currIndice === 0 || currIndice < length){
            return {nextIndice: currIndice+1, nextDirection: 'forward'}
        }else if(currIndice < length+1){
            return {nextIndice: currIndice-1, nextDirection: 'reverse'}
        }else{
            return {nextIndice: 0, nextDirection: 'forward'}
        }
    }else{
        if(currIndice > 0){
            return {nextIndice: currIndice-1, nextDirection: 'reverse'}
        }else if(currIndice === 0){
            return {nextIndice: currIndice+1, nextDirection: 'forward'}
        }else{
            return {nextIndice: 0, nextDirection: 'reverse'}
        }
    }
};

const Typewriter = ({ textArray=['Kuala Lumpur', 'Bali', 'Bangkok'], text, delay, infinite }) => {
  const [currentText, setCurrentText] = useState('');
  const [arrayIndice, setArrayIndice] = useState(0);
  const [direction, setDirection] = useState('forward');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    let timeout;

    if (currentIndex <= text.length) {
        timeout = setTimeout(() => {
          let arrayPosition = arrayIndice;
        let {nextIndice, nextDirection} = getIndiceFromLength(textArray[arrayPosition], currentIndex, direction);
        if(nextIndice===0 && nextDirection==='reverse'){
            if(arrayIndice === textArray.length-1){
                arrayPosition = 0;
                setArrayIndice(0);
            }else{
                arrayPosition = arrayIndice+1;
                setArrayIndice(c => c+1);
            }
        }
        // setCurrentText(prevText => prevText + text[nextIndice]);
        // console.log('----------------- || ', text.substr(0, nextIndice));
        setCurrentText(textArray[arrayPosition].substring(0, nextIndice));
        // setCurrentIndex(prevIndex => prevIndex + 1);
        setCurrentIndex(nextIndice);
        setDirection(nextDirection);
      }, textArray[arrayIndice].length === currentIndex ? 3000 : delay);

    } else if (infinite) { // ADD THIS CHECK
      setCurrentIndex(0);
      setCurrentText('');
    }

    return () => clearTimeout(timeout);
  }, [currentIndex, delay, infinite, textArray, direction]);

  return <span>{currentText}</span>;
};

export default Typewriter;